// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hl4g","left":"styles_left__3ZpzY","desktopActions":"styles_desktopActions__PrLZ_","title":"styles_title__299ex"};